// The `frontendAppConfig` is a singleton, similar to the next.js config, and stores
// the SSR initial configuration object in memory. It is intended for INTERNAL
// USE ONLY within the frontend-app library.
//
// This pattern is necessary to keep the developer experience reasonable for
// engineers. For example, the `buildStaticAssetPath` utility function
// requires access to configuration information. If it was not able to access
// the `frontendAppConfig` singleton, the config object would need to be passed to
// *every* `buildStaticAssetPath` call, turning this API:
//
// ```
// buildStaticAssetPath('images/my-image.png');
// ```
//
// Into this API:
//
// ```
// import frontendAppConfig from '../config/frontend-app.config.js';
// buildStaticAssetPath('images/my-image.png', config);
// ```
let frontendAppConfig = null;

export const getFrontendAppConfig = () => frontendAppConfig;
export const setFrontendAppConfig = newConfig =>
  (frontendAppConfig = newConfig);
